import getWithToken from './base/get-with-token'

const getWaterUsagePerDaOfLastYear = (type, searchData) => getWithToken(`/water-usage-per-day-of-last-year?type=${type}`)({
    ...searchData,
})

export default getWaterUsagePerDaOfLastYear